<template>
  <div class="organization-settings-tab-group">
    <div v-if="pageLoading" class="organization-settings-tab-group">
      <div
        v-for="item in tabsToShow"
        :key="item"
        class="organization-settings-tab-item"
      >
        <v-skeleton-loader type="heading" class="tab-item-loader" width="160" />
      </div>
    </div>
    <div
      v-for="{ name, title } in tabsToShow"
      v-else
      :key="name"
      class="organization-settings-tab-item"
    >
      <router-link :to="{ name }" class="tab-link">
        <span>{{ title }}</span>
        <FirstDraftStars
          v-if="name === 'ai-settings'"
          class="organization-settings-ai-tab-stars"
          aria-hidden="true"
        />
      </router-link>
    </div>
  </div>
  <div class="organization-settings-tab-content">
    <router-view />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import FirstDraftStars from '@ui/assets/icons/First_Draft_Stars.svg?component';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppLoading } from '@/stores/app/loading';
import { getVisibleOrganizationSettingsTabs } from '@/helpers/organizationSettingsTabs';

const authDataStore = useAppAuthData();

const appLoadingStore = useAppLoading();
const { pageLoading } = storeToRefs(appLoadingStore);

const emit = defineEmits(['track-page-load']);

onMounted(() => {
  emit('track-page-load', { page: 'Organization Settings' });
});

const tabsToShow = computed(() => getVisibleOrganizationSettingsTabs(authDataStore));
</script>

<style scoped lang="less">
.organization-settings-tab-group {
  display: flex;
  width: fit-content;
  height: 52px;
  align-items: center;

  div:first-of-type {
    .tab-link, .tab-item-loader {
      border-top-left-radius: 10px;
    }
  }

  div:last-of-type {
    .tab-link, .tab-item-loader {
      border-top-right-radius: 10px;
    }
  }
}

.organization-settings-tab-item {
  display: flex;
  align-items: center;
  height: 100%;

  &:not(:last-child) {
    border-right: 1px solid @stroke-default;
  }
}

.tab-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  width: 100%;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 500;
  color: @text-darkest;
  background: @grey-400;

  &:visited {
    color: @text-darkest;
  }
}

.organization-settings-ai-tab-stars {
  height: 18px;
  width: 18px;
}

.router-link-active.tab-link, .router-link-active.tab-link:visited {
  color: @text-brand;
  background: @white;
}

.organization-settings-tab-content {
  background: @white;
  padding-top: 12px;
}
</style>
